import { AppointmentDurationInNumbers } from '@avanta/shared/constants/appointments';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { Tag, Tags } from 'lucide-react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AppointmentsReservePayload } from 'pages/Appointments/AppointmentsReserve/types';

export const Pack = (): React.ReactElement => {
  const { watch } = useFormContext();
  const selectedPack = watch(AppointmentsReservePayload.selectedPack);
  const { grantedSessions } = selectedPack ?? {};
  const Icon = grantedSessions === AppointmentDurationInNumbers.DURATION_DOUBLE ? Tag : Tags;
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);

  return (
    <div className="flex gap-2 am-lg:gap-4 am-lg:items-center p-3 am-lg:p-4 rounded-xl bg-mint-100">
      <Icon strokeWidth={1.25} className={cn('size-8 am-lg:size-10 shrink-0 text-teal-600')} />
      <div className="flex gap-1 flex-col">
        <p className="text-sm text-denim-500 font-medium leading-4">
          {t(`AppointmentsReserve.Steps.confirmation.packName.${grantedSessions}`)}
        </p>
        <p className="text-sm text-gray-400 leading-4">
          {t(`AppointmentsReserve.Steps.confirmation.packDescription.${grantedSessions}`)}
        </p>
      </div>
    </div>
  );
};
